import { Component } from '@angular/core';
import { MemberService } from '../../../core/members/member.service';
import { SettingsService } from '../../../core/settings/settings.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LoyaltyClubHeaderComponent } from '@app/shared/components/loyalty-club-header/loyalty-club-header.component';
import { AsyncPipe } from '@angular/common';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';
import { PROFILE_DESTROY_FINISH_PATH } from '@app/+profile-form/profile-routes';
import { combineLatest, Observable } from 'rxjs';
import { MemberInterface } from '@app/core/_models/member-interface';

@Component({
  selector: 'app-delete-profile',
  templateUrl: './delete-profile.component.html',
  imports: [
    TopNavbarComponent,
    RouterLink,
    TranslatePipe,
    LoyaltyClubHeaderComponent,
    AsyncPipe,
    LoyaltyClubFooterComponent,
  ],
})
export class DeleteProfileComponent {
  protected settings$ = this.settingsService.getSettingsOnce();
  protected memberIdentifier$ = this.getMemberIdentifier();

  constructor(private router: Router,
              private route: ActivatedRoute,
              private settingsService: SettingsService,
              private memberService: MemberService) {}

  protected submit(): void {
    this.memberService.destroy()
      .subscribe(() => this.onDestroySuccess());
  }

  private onDestroySuccess(): void {
    this.router.navigate(['..', PROFILE_DESTROY_FINISH_PATH], { relativeTo: this.route, replaceUrl: true });
  }

  private getMemberIdentifier(): Observable<string> {
    return combineLatest([
      this.getMember(),
      this.isMsisdnClub(),
    ]).pipe(
      map(([member, isMsisdnClub]) => {
        if (isMsisdnClub && member?.properties?.msisdn) { return `+${member.properties.msisdn}`; }
        return member?.properties?.email;
      }),
    );
  }

  private getMember(): Observable<Partial<MemberInterface>> {
    return this.memberService.get()
      .pipe(
        filter((member) => !!member),
      );
  }

  private isMsisdnClub(): Observable<boolean> {
    return this.settingsService.getSettingsOnce().pipe(
      map((settings) => settings.schemaObject.isMsisdnIdentifier()),
    );
  }
}
